import Vue from 'vue';
import api from '../../utils/api';
import utilities from '../../utils/utilities';
import router from '../../router';
import constants from '../constants';

// initial state
const state = {
    isEmailConfirmationPending: false,

    email: '',
    password: '',
    confirmPassword: '',
    name: '',
    company: '',
    timezone: null,
    termsAccepted: false,
    errors: {},

    emailCheckTimer: null,

    confirmedSuccessfully: null
};

// mutations
const mutations = {
    init(state) {
        state.isEmailConfirmationPending = false;
        state.password = '';
        state.confirmPassword = '';
        state.errors = {};
        if (state.emailCheckTimer) {
            clearInterval(state.emailCheckTimer);
        }
        state.emailCheckTimer = null;
    },
    isEmailConfirmationPending(state, isEmailConfirmationPending) {
        state.isEmailConfirmationPending = isEmailConfirmationPending;
    },
    emailCheckTimer(state, emailCheckTimer) {
        state.emailCheckTimer = emailCheckTimer;
    },
    confirmedSuccessfully(state, confirmedSuccessfully) {
        state.confirmedSuccessfully = confirmedSuccessfully;
    },
    email(state, email) {
        state.email = email;
    },
    password(state, password) {
        state.password = password;
    },
    confirmPassword(state, confirmPassword) {
        state.confirmPassword = confirmPassword;
    },
    name(state, name) {
        state.name = name;
    },
    company(state, company) {
        state.company = company;
    },
    timezone(state, timezone) {
        state.timezone = timezone;
    },
    termsAccepted(state, termsAccepted) {
        state.termsAccepted = termsAccepted;
    },
    errors(state, errors) {
        state.errors = errors;
    }
};

// getters
const getters = {
};

const functions = {
    checkEmail(store) {
        api.get(`/api/account/checkEmail/${store.state.email}`).then(function(response) {
                const result = response.body;
                if (result === true) {
                    clearInterval(store.state.emailCheckTimer);
                    store.commit('emailCheckTimer', null);

                    //Setting test values
                    store.commit('email', 'john@example.com');
                    store.commit('password', 'password');

                    api.post(
                        '/api/account/signin',
                        {
                            email: store.state.email,
                            password: store.state.password
                        },
                        'signin/errors').then(
                        response => {
                            const authorizationData = response.body;

                            try {
                                localStorage.setItem(constants.tokenKey, JSON.stringify(authorizationData));
                            } catch (e) {
                                //localstorage is not supported (it could be if external cookies are turned off and you are running app in iframe)
                            }
                            router.push({
                                name: 'dashboard'
                            });
                            Vue.http.headers.common['Authorization'] = 'Bearer ' + authorizationData.token;
                            store.dispatch('settings/initAccount',
                                authorizationData,
                                { root: true });
                        },
                        function() {
                        });
                }
            },
            function() {

            });
    }
};

// actions
const actions = {
    load(store) {
        store.commit('init');
    },
    signup(store, btn) {
        utilities.disableButton(btn);
        api.post(
            '/api/account/signup',
            {
                email: store.state.email,
                password: store.state.password,
                confirmPassword: store.state.confirmPassword,
                name: store.state.name,
                company: store.state.company,
                timezone: store.state.timezone,
                termsAccepted: store.state.termsAccepted,
                culture: store.rootState.settings.culture
            },
            'signup/errors').then(
            function() {
                store.commit('emailCheckTimer', setInterval(function() { functions.checkEmail(store); }, 10000));
                store.commit('isEmailConfirmationPending', true);
            },
            function() {
                utilities.enableButton(btn);
            });
    },
    openSignIn(store) {
        router.push({
            name: 'signin',
            query: { l: store.rootState.settings.culture }
        });
    },
    //Setters
    setEmail(store, payload) {
        store.commit('email', payload);
    },
    setPassword(store, payload) {
        store.commit('password', payload);
    },
    setConfirmPassword(store, payload) {
        store.commit('confirmPassword', payload);
    },
    setName(store, payload) {
        store.commit('name', payload);
    },
    setCompany(store, payload) {
        store.commit('company', payload);
    },
    setTimezone(store, payload) {
        store.commit('timezone', payload);
    },
    setTermsAccepted(store, payload) {
        store.commit('termsAccepted', payload);
    },
    setConfirmedSuccessfully(store, payload) {
        store.commit('confirmedSuccessfully', payload);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/signup.js